import React from 'react';
import { Link } from 'react-router-dom';

import DragonImg from "~/assets/images/dailyGoals/dragon-hit.png";
import CheckMark from "../CheckMark";


const PlayDragonHitGoal = ({status})=> {

  return (
    <Link className="item-goal" to={"/tournament"}>
      <CheckMark done={status} />
      <div>
        <h5 className={"item-title"}> 1 Dragon Hit score in Tournament </h5>
        <p> Play one game and get a score into our daily Tournament 🔥</p>
      </div>
      <img src={DragonImg} className="icon"/>
    </Link>
  )
}

export default PlayDragonHitGoal;
